<template>
  <section class="card" data-testid="breakdowns">
    <div class="card-header d-flex flex-wrap gap-4">
      <div class="stat-tile" data-testid="summary-all">
        <div class="stat-label text-uppercase text-body-tertiary">
          {{ $t("inventory_selection.available") }}
        </div>
        <div class="stat-value">{{ available.mwh }} MWh</div>
        <div class="stat-detail text-body-tertiary">
          {{
            $t(
              "inventory_selection.row_count",
              { count: available.count },
              available.count
            )
          }}
        </div>
      </div>
      <div v-if="selected" class="stat-tile" data-testid="summary-selected">
        <div class="stat-label text-uppercase text-body-tertiary">
          {{ $t("inventory_selection.selected") }}
        </div>
        <div class="stat-value">{{ selected.mwh }} MWh</div>
        <div class="stat-detail text-body-tertiary">
          {{
            $t(
              "inventory_selection.row_count",
              { count: selected.count },
              selected.count
            )
          }}
        </div>
      </div>
    </div>
    <div class="breakdowns-body">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
/** A stat tile's figures: its MWh and how many rows hold them. */
export interface SummaryStat {
  mwh: number;
  count: number;
}

/**
 * The aggregate card every inventory page leads with: what is available, what is selected, and the
 * page's breakdown sections (default slot, `BreakdownSectionComponent`s) in a full-width grid. One
 * component, so the admin transaction page and both Soldera Inventory pages keep one layout.
 */
defineProps<{
  available: SummaryStat;
  /** Omitted for a fixed selection, where available and selected are the same thing. */
  selected?: SummaryStat | null;
}>();
</script>

<style lang="scss" scoped>
// As many section cards per row as the width allows, so nothing scrolls inside the card.
.breakdowns-body {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.75rem;
  padding: 1rem;
}

.stat-tile {
  min-width: 140px;
}

.stat-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.stat-detail {
  font-size: 0.75rem;
}
</style>
